<div class="container-fluid">
  <div class="header-container">
    <div class="page-header">
      <span class="fa fa-money"></span>{{ "bikeshop.menu.billing" | translate }}
    </div>
    <div class="loading" *ngIf="loading">
      <div class="loader"></div>
    </div>
  </div>


  <div class="plan-container">
    <div *ngFor="let plan of plans">      
      <div (click)="chosePackage(plan.package)" [ngClass]="{ 'plan': !stripeProductID, 'plan-subscribed': stripeProductID, 'selected': plan.id === stripeProductID, 'loading-plans': loading}">        
        <div *ngIf="plan.id === stripeProductID && subscription" class="subscribed-banner">{{'bikeshop.account.subscribed' | translate}}</div>
        <div class="header" [ngClass]="{'margin-top-16': plan.id === stripeProductID}">
          <div class="title">{{plan.planName}}</div>
          <div class="price" *ngIf="plan.price">{{plan.price}}<div>{{ 'bikeshop.account.per_month' | translate}}</div>
          </div>
        </div>
        <div class="plan-divider"></div>
        <div>
          <div class="extra-info">{{plan.extraInfo}}</div>
          <div *ngFor="let feature of plan.includes" class="feature">
            <div class="fa fa-check"></div>
            {{feature}}
          </div>
        </div>
        <div *ngIf="stripePortalURL && !loading && plan.id === stripeProductID" class="margin-top-32">
          <button pButton class="full-width accent" label="{{ 'bikeshop.account.manage_account' | translate }}"
            (click)="openStripePortal()"></button>
        </div>
      </div>
    </div>
  </div>
</div>